import { AppInfo } from "./AppManager";
import { ASSET_SERVER, getAppdataPath } from "../../config/env";
import { compareVersion } from "../../util/compareVersion";

const electron = (window as any).electron;
const fs = electron?.fs;
const path = electron?.path;

// 获取离线版内置的app列表
const getBuiltinAppData = (): Promise<AppInfo[]> => {
    // 如果fs不可用，返回空数组
    if (!fs || !path || !electron) {
        return Promise.resolve([]);
    }
    return fs.readFile(path.join(electron.getAppPath(), "applications/apps/app.json"), {encoding: "utf-8"}).then((data: string | ArrayBuffer) => {
        // 将字符串解析成对象
        let appData: AppInfo[] = [];
        try {
            appData = JSON.parse(data.toString());
        } catch (e) {console.log(e)}
        // 解析数据
        const appInnerData: AppInfo[] = appData.map(item => {
            const _item: AppInfo = {
                ...item,
                hasUpdate: false,
                status: 0, // 已下载
                isBuiltin: true, // 标为内置
                cover:path.join(electron.getAppPath(), "applications/apps/", item.id, item.cover),
                dynamicCover: item.dynamicCover?path.join(electron.getAppPath(), "applications/apps/", item.id, item.dynamicCover):undefined,
            }
            return _item;
        })
        return appInnerData
    }).catch(() => [])
}

// 获取本地的设备列表
const getLocalAppData = (): Promise<AppInfo[]> => {
    // todo: 在线版兼容(在线版没有local)
    // 如果fs不可用，返回空数组
    if (!fs || !path) {
        return Promise.resolve([]);
    }
    return fs.readFile(path.join(getAppdataPath(), "applications/apps/app.json"), {encoding: "utf-8"}).then((data: string | ArrayBuffer) => {
        // 将字符串解析成对象
        let appData: AppInfo[] = [];
        try {
            appData = JSON.parse(data.toString());
        } catch {}
        // 解析数据
        const appInnerData: AppInfo[] = appData.map(item => {
            const _item: AppInfo = {
                ...item,
                isBuiltin: false,
                hasUpdate: false,
                status: 0, // 已下载
            }
            return _item;
        })
        return appInnerData
    }).catch(() => [])
}


// 获取服务器的extension列表
export const getServerAppData = async (): Promise<AppInfo[]> => {
    // 将字符串解析成对象
    let appData: AppInfo[] = [];
    try {
        const response = await fetch(`${ASSET_SERVER}/applications/apps/app.json`, {
            method: 'GET',
            headers: {
                'Cache-Control': 'no-cache', // 防止缓存
                'Pragma': 'no-cache'         // 兼容旧版HTTP
            }
        })
        appData = await response.json()
        // 解析数据
        return appData.map(item => {
            const _item: AppInfo = {
                ...item,
                isBuiltin: false,
                hasUpdate: false,
                status: 1, // 未下载
            }
            return _item;
        })
    } catch (e) {
        console.log("e=====", e)
        return appData
    }
}

// 获取应用列表
export const getAppData = (callback?: (data: AppInfo[]) => void): Promise<AppInfo[]> => {
    // 1.获取内置(安装目录/extensions)
    const promise1 = getBuiltinAppData();

    // 2.获取本地
    const promise2 = getLocalAppData();

    // 3.获取服务器
    const promise3 = getServerAppData();

    // 4.每次数据获取成功都调用一次回调
    let rets: [AppInfo[], AppInfo[], AppInfo[]] = [[], [], []];
    const parseData = () => {
        let appData: AppInfo[] = [];
        // 合并数据
        const builtinData = rets[0];
        const localData = rets[1];
        const serverData = rets[2];

        builtinData.forEach(item => {
            // 没有就新增
            const index = appData.findIndex(item1 => item1.id === item.id)
            if (index === -1) {
                appData.push(item)
                return;
            }
            // 对比版本
            if (compareVersion(item.version, appData[index].version)) {
                appData.splice(index, 1, item)
            }
        });

        localData.forEach(item => {
            // 没有就新增
            const index = appData.findIndex(item1 => item1.id === item.id)
            if (index === -1) {
                appData.push(item)
                return;
            }
            // 对比版本
            if (compareVersion(item.version, appData[index].version)) {
                appData.splice(index, 1, item)
            }
        })

        serverData.forEach(item => {
            // 没有就新增
            const index = appData.findIndex(item1 => item1.id === item.id)
            if (index === -1) {
                appData.push(item)
                return;
            }
            // 对比版本
            if (compareVersion(item.version, appData[index].version)) {
                // 云端版本更高, 设置为"有更新"状态
                appData[index].hasUpdate = true;
            }
        })

        return appData
    }
    const promiseList = [promise1, promise2, promise3].map((promise, index) => {
        return promise.then((data) => {
            // 缓存数据
            rets[index] = data;
            const data_ = parseData();
            // 刷新数据
            if (callback) callback(data_);
            return data_;
        }).catch(e => console.error('获取设备列表失败', index, e))
    })
    return Promise.all(promiseList).then(()=>parseData());
}
